import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  DialogActions,
  DialogContent,
  Divider
} from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';

import FMSModal, { FMSModalTitle } from 'src/common/FMSModal';
import InputField from 'src/common/formFields/InputField';
import Loader from 'src/common/Loader';
import { setErrorInfo, setSuccessInfo } from 'src/redux/modalSlice';
import theme from 'src/theme';
import { mapCardsToDispenser } from 'src/redux/dispenserSlice';

import {
  mapFormModel,
  mapFormInitialValues,
  mapValidationSchema
} from './formModel/dispenserMapModel';

const NewMap = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    formId,
    formField: { fromAddress, toAddress }
  } = mapFormModel;

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      await dispatch(mapCardsToDispenser(values)).unwrap();

      setLoading(false);
      handleClose();

      dispatch(
        setSuccessInfo({
          successMsg: 'Cards mapped to dispenser successfully!'
        })
      );
    } catch (error) {
      setLoading(false);
      dispatch(
        setErrorInfo({
          errorMsg: error?.error_message || 'Failed to map cards'
        })
      );
    }
  };

  return (
    <FMSModal open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <FMSModalTitle title="MAP CARDS TO DISPENSER" onCancel={handleClose} />
      <Divider />

      {loading ? (
        <Loader />
      ) : (
        <Formik
          enableReinitialize
          initialValues={mapFormInitialValues}
          validationSchema={mapValidationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form id={formId}>
              <DialogContent
                sx={{
                  px: 4,
                  py: 3,
                  backgroundColor: theme.palette.background.default
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <InputField
                      name={fromAddress.name}
                      label={fromAddress.label}
                      fullWidth
                      inputProps={{ maxLength: 4 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <InputField
                      name={toAddress.name}
                      label={toAddress.label}
                      fullWidth
                      inputProps={{ maxLength: 4 }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions
                sx={{
                  p: 3,
                  justifyContent: 'flex-end',
                  gap: 2,
                  backgroundColor: theme.palette.background.default
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  autoCapitalize="none"
                  onClick={handleClose}
                  sx={
                  {
                    borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3
                  }
}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  autoCapitalize="none"
                  disabled={isSubmitting}
                  sx={
                    {
                      borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3
                    }
                  }
                >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </FMSModal>
  );
};

NewMap.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default NewMap;
